import { atom } from 'recoil';

export const showModalReservationState = atom({
    key: 'showModalReservationState',
    default: false
});

export const showModalEditFiltersState = atom({
    key: 'showModalEditFilters',
    default: false
});

export const showModalEditFiltersImgState = atom({
    key: 'showModalEditFiltersImg',
    default: false
});

export const showModalEditFiltersProcState = atom({
    key: 'showModalEditFiltersProc',
    default: false
});

export const hourSelectedState = atom({
    key: 'hourSelected',
    default: null
});

export const professionalSelectedState = atom({
    key: 'professional',
    default: null
});